<template>
  <div>
    <FormCard v-model="dataFieldRefs" :id="card.id" :fieldRefs="fieldRefs" :cardKey="card.key" :form="form" v-for="card, cardIndex in cards" :options="card.options" :subCaption="card.subCaption" :caption="card.caption" :rows="cards[cardIndex].rows" :fields="cards[cardIndex].fields" :tabs="cards[cardIndex].tabs">
      <slot v-if="card.key != ''" :slot="card.key"></slot>
    </FormCard>
  </div>
</template>
<script>
  import FormCard from './FormCard'
export default {
  name: 'FormCards',
  components: {
    FormCard
  },
  props: {
    cards: {
      type: Array,
      default: function () { return [] }
    },
    form: {
      type: Object,
      default: function () { return {} }
    },
    fieldRefs: {
      type: Array,
      default: function() { return [] }
    },
    value: {
      type: Array | Object,
      default: function() { return [] }
    }
  },
  watch: {
    value(val) {
      this.dataFieldRefs = val
    },
    dataFieldRefs(val) {
      this.$emit('input', val)
    }
  },
  mounted() {
    this.dataFieldRefs = this.value
  },
  data: function () {
    return {
      dataFieldRefs: [],
    }
  }
}
</script>

